import { render } from "./EmojiModel.vue?vue&type=template&id=77ec1a1c"
import script from "./EmojiModel.vue?vue&type=script&lang=js"
export * from "./EmojiModel.vue?vue&type=script&lang=js"

import "./EmojiModel.vue?vue&type=style&index=0&id=77ec1a1c&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__